import React, { useEffect, useState } from "react";
import { Image, Modal, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdLocationOn, MdOutlineEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import illusMobility from "../../../assets/images/illusMobility.jpg";
import QRCode from "react-qr-code";
import ComponentCalendrier from "./ComponentCalendrier";
import ComponentLoader from "../../layout/ComponentLoader";
import ModalMobilities from "../../admin/localisation/ModalMobilities";

const ModalDetailMobility = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const { mobility, show, handleClose, calendrier } = props;
  const [showEditMobility, setShowEditMobility] = useState(false);
  const [loader, setLoader] = useState(true);

  const qrCodeDisponibilites = () => {
    let urlEspace =
      process.env.REACT_APP_URL_EASYGOUV +
      "choixInstance?instance=" +
      ReduxInstance._id +
      "&page=espaces" +
      "&popup=" +
      mobility._id;
    return urlEspace;
  };

  /* UTILE POUR LES ADMINISTRATEURS */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const handleCloseEditMode = () => {
    setShowEditMobility(false);
    handleClose();
  };

  const LoaderTimeout = () => {
    setTimeout(() => {
      setLoader(false);
    }, 4000);
    return loader && <ComponentLoader />;
  };

  useEffect(() => {
    if (show) setLoader(true);
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {show && (
        <>
          <Modal
            size="lg"
            show={show && !showEditMobility}
            onHide={handleClose}
            className="modalDetailMobility"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("public.pageTierslieux.titleColonne5")}</Modal.Title>
              {isAdminEasygouv() && (
                <div className="flex-grow-1 text-end">
                  <MdOutlineEdit
                    size="1.5em"
                    role="button"
                    onClick={() => setShowEditMobility(true)}
                    className=""
                  />
                </div>
              )}
            </Modal.Header>
            <Modal.Body className="whiteSpace">
              <div className="d-flex flex-wrap justify-content-center">
                <Image
                  className="mobilityBig"
                  src={
                    mobility.cardPic
                      ? process.env.REACT_APP_URL_EXPRESS + "images/mobility/" + mobility.cardPic
                      : illusMobility
                  }
                />
                <span className="flex-grow-1 p-2">
                  <h2>{mobility.nom}</h2>

                  <p className="d-flex">
                    <MdLocationOn size="1.5em" className="me-1" />
                    <span>
                      {mobility.localisation.nom ? mobility.localisation.nom : "-"} <br />
                    </span>
                  </p>
                </span>
              </div>
              <div className="mt-3">
                <Tabs defaultActiveKey={mobility.email ? "calendrier" : "usages"} className="mb-3 ">
                  <Tab eventKey="usages" title={t("public.pageTierslieux.titleColonne3")}>
                    {mobility.procedure}
                  </Tab>

                  {mobility.email && (
                    <tab eventKey="calendrier" title={t("public.pageTierslieux.calendrier")}>
                      {calendrier ? (
                        <ComponentCalendrier calendrier={calendrier} />
                      ) : (
                        LoaderTimeout()
                      )}
                    </tab>
                  )}

                  {mobility.email && (
                    <tab
                      eventKey="qrCodeDisponibilites"
                      title={t("public.pageTierslieux.qrCodeDisponibilites")}
                      className="text-center"
                    >
                      <QRCode value={qrCodeDisponibilites()} className="m-2" size={200} />
                      <br />

                      {t("public.pageTierslieux.qrCodeDisponibilitesExplications")}
                    </tab>
                  )}
                </Tabs>
              </div>
            </Modal.Body>
          </Modal>
          <ModalMobilities
            show={showEditMobility}
            id={mobility.localisation._id}
            handleClose={handleCloseEditMode}
            editModeForceMobility={mobility}
          />
        </>
      )}
    </>
  );
};

export default ModalDetailMobility;
